import Request from '../Request.utils'
export interface ITriggerCronJobsRequestBody {
  jobName: string;
}


class SystemAPI {
  cronJobsStatus = async () => {
    const res = await Request.call('/api/cron-jobs-status', 'GET', undefined, undefined, undefined, );
    return res;
  }
  triggerCronJobs = async (body: ITriggerCronJobsRequestBody) => {
    const res = await Request.call('/api/trigger-cron-jobs', 'POST', undefined, undefined, body, );
    return res;
  }
  appMinVersion = async () => {
    const res = await Request.call('/api/app-min-version', 'GET', undefined, undefined, undefined, );
    return res;
  }
}
export default new SystemAPI()